import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const PaymentTypesRedux = createActions(
  {
  },
  {
    prefix: 'PAYMENT_TYPES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = PaymentTypesRedux
export const PaymentTypesTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})


export const reducer = createReducer(
  INITIAL_STATE, {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/PaymentTypesRedux.js